import { v4 as uuidv4 } from 'uuid';

import RequestBuilder from '../Lib/Requests';
import AuthService from './AuthService';

export default class OrganizationService {
  api = new RequestBuilder();
  auth = new AuthService();

  buildFullOrgWithChildrenRequest(orgID, children, cancelToken) {
    return {
      service: 'account',
      endpoint: `/org/${orgID}`,
      method: 'get',
      params: { children },
      cancelToken,
    };
  }
  fetchFullOrgDetails = async (
    orgID = this.auth.getCurrentOrgID(),
    children = false,
    cancelToken
  ) => {
    const { data = {} } = await this.api.request(
      this.buildFullOrgWithChildrenRequest(orgID, children, cancelToken)
    );
    return data;
  };
  buildAllOrganizationUsersRequest(orgID, cancelToken) {
    return {
      service: 'account',
      endpoint: `/org/${orgID}/users`,
      method: 'get',
      cancelToken,
    };
  }
  async fetchAllOrganizationUsers(orgID, cancelToken) {
    const { data = {} } = await this.api.request(
      this.buildAllOrganizationUsersRequest(orgID, cancelToken)
    );
    return data;
  }

  buildCreateSubOrgRequest(data) {
    return {
      service: 'account',
      endpoint: '/org',
      method: 'post',
      data,
    };
  }
  async createSubOrg(body) {
    const { data } = await this.api.request(
      this.buildCreateSubOrgRequest(body)
    );
    return data;
  }

  buildDeleteOrgRequest(orgID, params, cancelToken) {
    return {
      service: 'account',
      endpoint: `/org/${orgID}`,
      method: 'delete',
      params,
      cancelToken,
    };
  }
  deleteOrg(orgID, params, cancelToken) {
    return this.api.request(
      this.buildDeleteOrgRequest(orgID, params, cancelToken)
    );
  }

  buildOrgSearchRequest(params, cancelToken) {
    return {
      service: 'account',
      endpoint: '/org/search',
      method: 'get',
      params,
      cancelToken,
    };
  }
  async searchOrgs(params, cancelToken) {
    const { data = {} } = await this.api.request(
      this.buildOrgSearchRequest(params, cancelToken)
    );
    return data;
  }

  buildRegenerateOrgSASRequest(orgID, cancelToken) {
    return {
      service: 'account',
      endpoint: `/org/${orgID}/regenerateSas`,
      method: 'put',
      data: { policyID: uuidv4() },
      cancelToken,
    };
  }

  async regenerateOrgSAS(orgID, cancelToken) {
    const { data = {} } = await this.api.request(
      this.buildRegenerateOrgSASRequest(orgID, cancelToken)
    );
    return data;
  }

  buildMoveOrgRequest(orgID, data, cancelToken) {
    return {
      service: 'account',
      endpoint: `/org/${orgID}/move`,
      method: 'put',
      data,
      cancelToken,
    };
  }

  async moveOrg(orgID, params, cancelToken) {
    const { data = {} } = await this.api.request(
      this.buildMoveOrgRequest(orgID, params, cancelToken)
    );
    return data;
  }

  buildAcceptOrgTermsRequest(orgID, userID, data, cancelToken) {
    return {
      cancelToken,
      data,
      endpoint: `/org/${orgID}/user/${userID}/terms`,
      method: 'put',
      service: 'account',
    };
  }
  async acceptOrgTerms(orgID, userID, body, cancelToken) {
    const { data } = await this.api.request(
      this.buildAcceptOrgTermsRequest(orgID, userID, body, cancelToken)
    );
    return data;
  }
}
